import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { UseFormReturn, useWatch } from "react-hook-form";

import shipCore from "../../core/ship.core";
import CloseIcon from "../../icons/iconClose.comp";
import CountrySelectorClick from "./countrySelectorClick.comp";

export default function CountrySelectorInput({ methods, multiple = true }: { methods: UseFormReturn<any>; multiple?: boolean }) {
  const { locale } = useRouter();

  const countryIds = useWatch({
    control: methods.control,
    name: "countryIds",
  });

  const {
    data: countryList,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["countryList", locale],
    queryFn: shipCore.getCountryList,
  });

  const Badge = ({ countryId }: { countryId: string }) => {
    function deleteCountry() {
      const currentCountryIds = methods.getValues("countryIds");
      const newCountryIds = currentCountryIds.filter((id) => id !== countryId);
      methods.setValue("countryIds", newCountryIds);
    }

    if (isLoading) return null;
    if (isError) return null;

    const country = countryList!.find((c) => c.id === countryId);

    return (
      <div className="flex items-center px-5 py-2.5 text-sm font-medium text-center text-white bg-blue-700 rounded-lg focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:focus:ring-blue-800">
        {country?.name}
        <button
          className="flex items-center justify-center w-4 h-4 ml-2 text-xs font-semibold text-blue-800 bg-blue-200 rounded-full hover:bg-red-400 hover:text-white"
          onClick={deleteCountry}
        >
          <CloseIcon />
        </button>
      </div>
    );
  };

  return (
    <div>
      <input type="hidden" {...methods.register("countryIds")} />
      <CountrySelectorClick
        onSelected={(country) => {
          const currentCountryIds = methods.getValues("countryIds");
          const newCountryIds = multiple ? Array.from(new Set(currentCountryIds).add(country.id)) : [country.id];
          methods.setValue("countryIds", newCountryIds);
        }}
      />
      <div className="mt-2">
        <ul className="flex flex-wrap gap-2">
          {countryIds &&
            countryIds.map((id) => (
              <li key={id}>
                <Badge countryId={id} />
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
}
